/**
 * Типы рабочих групп. Модуль для работы с API
 * @module unitTypes
 */

import { maxPerPage } from "@/constants";

/**
 * Получение списка типов рабочих групп
 * @param {Object} params - Параметры запроса
 * @returns {Promise<Object>} - список типов рабочих групп
 * @throws {Error} - ошибка при получении данных
 */
export const getList = async (params) => {
  const queryString = new URLSearchParams(params).toString();

  try {
    const response = await fetch(`/api/unittypes?${queryString}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при получении данных. ${data.error || "Обновите страницу"}`
      );
    }

    return data;
  } catch (err) {
    throw err;
  }
};

/**
 * Получение списка типов рабочих групп без пагинации
 * @param {Object} params - Параметры запроса
 * @returns {Promise<Object>} -список типов рабочих групп
 * @throws {Error} - ошибка при получении данных
 */
export const getUnitTypeOptions = async (params) => {
  const queryString = new URLSearchParams({
    ...params,
    page: 1,
    perpage: maxPerPage,
  }).toString();

  try {
    const response = await fetch(`/api/unittypes?${queryString}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при получении данных. ${data.error || "Обновите страницу"}`
      );
    }

    return data;
  } catch (err) {
    throw err;
  }
};

/**
 * Получение типа рабочей группы по uuid
 * @param {string} uuid - UUID типа рабочей группы
 * @returns {Promise<Object>} - данные типа рабочей группы
 * @throws {Error} - ошибка при получении данных
 */
export const getItem = async (uuid) => {
  try {
    const response = await fetch(`/api/unittype?uuid=${uuid}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при получении данных. ${data.error || "Обновите страницу"}`
      );
    }

    return data.item;
  } catch (err) {
    throw err;
  }
};

/**
 * Создание типа рабочей группы
 * @param {Object} item - данные типа рабочей группы
 * @returns {Promise<Object>} - данные созданного типа рабочей группы
 * @throws {Error} - ошибка при создании данных
 */
export const createItem = async (item) => {
  try {
    const response = await fetch("/api/unittype", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при создании данных. ${data.error || "Попробуйте снова"}`
      );
    }

    return data.item;
  } catch (err) {
    throw err;
  }
};

/**
 * Обновление типа рабочей группы
 * @param {Object} item - данные типа рабочей группы
 * @returns {Promise<Object>} - обновленные данные типа рабочей группы
 * @throws {Error} - ошибка при обновлении данных
 */
export const updateItem = async (item) => {
  try {
    const response = await fetch("/api/unittype", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при обновлении данных. ${data.error || "Попробуйте снова"}`
      );
    }

    return data.item;
  } catch (err) {
    throw err;
  }
};

/**
 * Удаление типа рабочей группы
 * @param {Object} item - данные типа рабочей группы
 * @returns {Promise<Object>} - удаленные данные типа рабочей группы
 * @throws {Error} - ошибка при удалении данных
 */
export const deleteItem = async (item) => {
  try {
    const response = await fetch("/api/unittype", {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при удалении данных. ${data.error || "Попробуйте снова"}`
      );
    }

    return data.item;
  } catch (err) {
    throw err;
  }
};
